export default __webpack_public_path__ + "static/blob15-bab82abd20531cb3421c12ed87f990c4.svg";